import { NextPageWithLayout } from 'next';
import React from 'react';
import { useIntl } from 'react-intl';
import { Grid, GridCell } from '@fuww/library/src/Grid';
import { Breadcrumbs } from '@fuww/library/src/Breadcrumb';
import Head from '../components/Head';
import Layout from '../components/Layout';
import NewsletterForm from '../components/NewsletterForm';
import messages from '../lib/messages';
import HomeLink from '../components/HomeLink';
import LinkAndAnchor from '../components/LinkAndAnchor';
import Hero from '../components/Hero';

const Newsletter: NextPageWithLayout = () => {
  const intl = useIntl();

  const breadcrumbs = [
    <HomeLink />,
    <LinkAndAnchor
      route="newsletter"
      passHref
    >
      {intl.formatMessage(messages.newsletter)}
    </LinkAndAnchor>,
  ];

  const headerImageUrls = {
    mobile: [
      'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=34,quality=10,width=42/https://media.fashionunited.com/media/hero/2023/newsletter_hero_image.png',
      'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=288,quality=70,width=360/https://media.fashionunited.com/media/hero/2023/newsletter_hero_image.png',
      'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=576,quality=70,width=720/https://media.fashionunited.com/media/hero/2023/newsletter_hero_image.png',
    ],
    desktop: [
      'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=8,quality=10,width=42/https://media.fashionunited.com/media/hero/2023/newsletter_hero_image.png',
      'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=277,quality=70,width=1350/https://media.fashionunited.com/media/hero/2023/newsletter_hero_image.png',
      'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=526,quality=70,width=2560/https://media.fashionunited.com/media/hero/2023/newsletter_hero_image.png',
      'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=1052,quality=70,width=5120/https://media.fashionunited.com/media/hero/2023/newsletter_hero_image.png',
    ],
  };

  return (
    <>
      <Head
        title={intl.formatMessage(messages.newsletterMetaTitle)}
        description={intl.formatMessage(messages.newsletterMetaDescription)}
      />
      <Layout
        header={(
          <Hero
            imageUrls={headerImageUrls}
            alt="FashionUnited newsletter banner image"
          />
    )}
      >
        <Grid>
          <GridCell padding="24px">
            <Breadcrumbs
              crumbs={breadcrumbs}
            />
          </GridCell>
          <GridCell padding="24px">
            <NewsletterForm />
          </GridCell>
        </Grid>
      </Layout>
    </>
  );
};
Newsletter.getLayout = (page) => page;

export default Newsletter;
